import axios from "axios";
import { useTranslation } from "react-i18next";
import useEvent from "react-use-event-hook";

import {
  castErrorResult,
  createCatchErrorResult,
  createSuccessResult,
  GeoAreaApi,
  IGeoAreaGeom,
  Log,
  SimpleResult,
  simpleResultInvalidApiResponse,
} from "@ryde/shared";

export const useGeoAreasActions = () => {
  const { t } = useTranslation();

  const fetchGeoAreasGeom = useEvent(
    async ({
      geoAreasIds,
    }: {
      geoAreasIds: number[];
    }): Promise<SimpleResult<IGeoAreaGeom[]>> => {
      try {
        const result = await GeoAreaApi.getGeoAreasGeom({
          geoAreasIds,
        });

        if (!result) {
          return simpleResultInvalidApiResponse(t);
        }

        if (!result?.success || !result.data) {
          return castErrorResult(result);
        }

        return createSuccessResult(result.data);
      } catch (error) {
        if (axios.isCancel(error)) {
          Log.debug("Axios, request canceled", error);
          return createCatchErrorResult(error, t);
        }

        return createCatchErrorResult(error, t);
      }
    },
  );

  return {
    fetchGeoAreasGeom,
  };
};
